import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderselectapi } from "../../../../Components/Forms/renders";

const ChirpStackStep3 = ({ devices, alertprofile, onComplete, onBack, handleSubmit }) => {
  const onSubmit = (values) => {
    onComplete(values);
  };

  return (
    <div>
      <h4>Stap 3: Sensor Configuratie</h4>
      <p>Configureer de instellingen voor alle {devices.length} geselecteerde devices.</p>

      <div className="alert alert-info">
        <i className="fa fa-info-circle"></i> <strong>Info:</strong> Deze instellingen worden toegepast op alle geselecteerde devices.
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <h5><i className="fa fa-cog"></i> Basis Instellingen</h5>
            
            <Field
              className="form"
              name="active"
              validate={required({ msg: "Status is verplicht" })}
              label="Status van de sensoren"
              component={renderselect}
              options={{
                true: "Actief",
                false: "Uitgeschakeld",
              }}
            />

            <Field
              className="form"
              name="favo"
              validate={required({ msg: "Favoriet instelling is verplicht" })}
              label="Maak sensoren favoriet"
              component={renderselect}
              options={{
                true: "Ja",
                false: "Nee",
              }}
            />

            <Field
              className="form"
              name="sensor"
              validate={required({ msg: "Type sensor is verplicht" })}
              label="Type Sensor"
              component={renderselect}
              options={{
                electra: "Electra",
                "EM300-DI": "Milesigt EM300-DI Pulse Sensor",
                "em300-th": "Milesigt EM300-TH Temperature & Humidity Sensor",
                UC300: "Milesigt UC300",
                UC300_relais: "Milesigt UC300 Relais",
                "M114039-02": "M114039-02",
                energy_emu: "EMU PROFESSIONAL II",
                "SDM230-LoRaWAN": "SDM230-LoRaWAN",
                nke_watteco: "Sens'O - LoRaWAN Pulse",
                temperatuur: "Temperatuur externe Sensor",
                temperatuurint: "Temperatuur",
                CT303: "Milesigt CT303",
              }}
            />

            <Field
              className="form"
              name="soort"
              validate={required({ msg: "Soort sensor is verplicht" })}
              label="Soort Sensor"
              component={renderselect}
              options={{
                ampere: "Ampere Meter",
                electra: "Electra",
                gas: "Gas",
                temperatuur: "Temperatuur",
                water: "Water",
                relais: "Relais",
              }}
            />

            <Field name="label" type="input" component={renderField} label="Standaard label" />
            <Field name="group" type="input" component={renderField} label="Standaard groep" />
          </div>

          <div className="col-md-6">
            <h5><i className="fa fa-sliders"></i> Waardes & Limieten</h5>
            
            <Field name="minvalue" type="number" component={renderField} label="Minimale waarde correct" />
            <Field name="maxvalue" type="number" component={renderField} label="Maximale waarde correct" />
            <Field name="minvaluetemp" type="number" component={renderField} label="Minimale sensor waarde" />
            <Field name="maxvaluetemp" type="number" component={renderField} label="Maximale sensor waarde" />
            
            <h5><i className="fa fa-bell"></i> Alert Instellingen</h5>
            
            <Field name="alerts.sendminvalue" type="number" component={renderField} label="Minimale waarde voor alert" />
            <Field name="alerts.sendmaxvalue" type="number" component={renderField} label="Maximale waarde voor alert" />
            
            <Field
              className="form"
              name="alerts.uur"
              label="Interval van alerts"
              component={renderselect}
              options={{
                0: "Elke afwijking",
                1: "Maximaal 1 keer uur",
                2: "Maximaal 1 keer per dag",
                3: "Slim opgebouwd",
              }}
            />

            <Field 
              name="alertprofile" 
              type="input" 
              component={renderselectapi} 
              options={alertprofile} 
              label="Alert profiel" 
            />
          </div>
        </div>

        <hr />

        <div className="alert alert-warning">
          <h5><i className="fa fa-list"></i> Devices die geïmporteerd worden:</h5>
          <div style={{ maxHeight: "150px", overflowY: "auto" }}>
            {devices.map((device, index) => (
              <div key={index} className="row" style={{ marginBottom: "5px" }}>
                <div className="col-md-6">
                  <strong>{device.name || `Device ${index + 1}`}</strong>
                </div>
                <div className="col-md-6">
                  <code>{device.devEui}</code>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <button type="button" className="btn btn-default" onClick={onBack}>
              <i className="fa fa-arrow-left"></i> Terug
            </button>
          </div>
          <div className="col-md-6 text-right">
            <button type="submit" className="btn btn-success btn-lg">
              <i className="fa fa-download"></i> Import Starten ({devices.length} devices)
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

const ChirpStackStep3Form = reduxForm({
  form: "chirpstack_import_config",
  initialValues: {
    active: true,
    favo: false,
    sensor: "electra",
    soort: "electra",
    label: "",
    group: "ChirpStack Import",
    minvalue: 0,
    maxvalue: 1000,
    minvaluetemp: -50,
    maxvaluetemp: 100,
    alerts: {
      sendminvalue: 0,
      sendmaxvalue: 1000,
      uur: 0,
    },
  },
})(ChirpStackStep3);

export default connect()(ChirpStackStep3Form);